import { render, staticRenderFns } from "./asset-bar-share.vue?vue&type=template&id=6a8ae50d&"
import script from "./asset-bar-share.vue?vue&type=script&lang=js&"
export * from "./asset-bar-share.vue?vue&type=script&lang=js&"
import style0 from "./asset-bar-share.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports